// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__N09fF","Open":"SideDrawer_Open__3zjmc","Close":"SideDrawer_Close__2nj33","Logo":"SideDrawer_Logo__A3VvN"};